import { FolderHeart, Inbox, ListTodo, Mails, ScanSearch, Tags } from 'lucide-react';
import { canEdit, canView } from '@nest-recruit/shared';
import type { router as AppRouter } from '../../router';
import { registerCommands, type Command } from '../../shell/command-registry';

/**
 * S25's palette entries (06-qol §1): the pools, advanced search, and ADMIN-11. Each names the
 * §L23 object it needs, so nobody is offered a screen that would refuse them.
 */
export function registerPoolCommands(router: typeof AppRouter): () => void {
  const commands: Command[] = [
    {
      id: 'pools.library',
      label: 'Talent pools',
      section: 'navigate',
      context: 'Candidates · POOL-01',
      permission: 'talent_pool',
      canSee: (session) => canView(session, 'talent_pool'),
      icon: FolderHeart,
      keywords: ['pool', 'silver', 'bench', 'rediscover', 'consent'],
      run: () => void router.navigate({ to: '/pools' }),
    },
    {
      id: 'pools.search',
      label: 'Find candidates (all filters)',
      section: 'navigate',
      context: 'Candidates · All candidates',
      permission: 'candidate',
      canSee: (session) => canEdit(session, 'candidate'),
      icon: ScanSearch,
      keywords: ['search', 'skills', 'experience', 'source', 'filter', 'sourcing'],
      run: () => void router.navigate({ to: '/candidates' }),
    },
    {
      id: 'pools.admin',
      label: 'Pools and tags',
      section: 'navigate',
      context: 'Admin · ADMIN-11',
      permission: 'hiring_setup',
      icon: Tags,
      keywords: ['tag', 'merge', 'rename', 'retire', 'pool'],
      run: () => void router.navigate({ to: '/admin/pools-and-tags' }),
    },
    // S26.
    {
      id: 'tasks.mine',
      label: 'My tasks',
      section: 'navigate',
      context: 'Tasks · COMM-04 · g then t',
      permission: 'activity_message',
      canSee: (session) => canEdit(session, 'activity_message'),
      icon: ListTodo,
      keywords: ['task', 'follow up', 'follow-up', 'overdue', 'todo', 'morning'],
      run: () => void router.navigate({ to: '/tasks' }),
    },
    {
      id: 'admin.messageTemplates',
      label: 'Message templates',
      section: 'navigate',
      context: 'Admin · ADMIN-09',
      permission: 'hiring_setup',
      icon: Mails,
      keywords: ['email', 'template', 'wording', 'letter', 'regret'],
      run: () => void router.navigate({ to: '/admin/message-templates' }),
    },
    {
      id: 'admin.inbox',
      label: 'Inbound mail',
      section: 'navigate',
      context: 'Admin · unassigned replies',
      permission: 'admin_config',
      icon: Inbox,
      keywords: ['reply', 'imap', 'mailbox', 'unassigned', 'inbox'],
      run: () => void router.navigate({ to: '/admin/inbox' }),
    },
  ];
  return registerCommands(commands);
}
